import { inject, Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { ApiService } from '../../../../core/services/ApiService';
import { IResponse } from '../../../../core/interfaces/IResponse';
import { IReservation } from '../interfaces/IReservation';
import { ReservationsStore } from '../stores/ReservationsStore';
import { HttpParams } from '@angular/common/http';
import { GuidUtils } from '../../../../core/utils/GuidUtils';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ReservationsService {

  private readonly _basePath = '/reservations';
  private readonly _apiService = inject(ApiService);
  private readonly _reservationsStore = inject(ReservationsStore);

  public getReservations(showId?: number): Observable<IResponse<IReservation[]>> {
    let httpParams = new HttpParams();

    if (showId) {
      httpParams = httpParams.append('showId', showId);
    }

    return this._apiService.get(this._basePath, httpParams)
      .pipe(
        map((res: IResponse<IReservation[]>) => {
          res.data = res.data.sortByKey('createdDate', 'desc');

          return res;
        }),
        tap(res => this._reservationsStore.selectedShowReservations.set(res.data))
      );
  }

  public cancel(seatIds: number[], showId: number): Observable<void> {
    return this._apiService.post(
      `${this._basePath}/cancel`,
      {
        seatIds,
        showId,
        operationId: GuidUtils.raw(),
      }
    );
  }

  public releaseReservations(
    payload: { showId: number; cineCardReservations: boolean; }[]
  ): Observable<IResponse<void>> {
    return this._apiService.post(
      `${this._basePath}/release-non-taken-reservations`,
      {
        reservations: payload,
        operationId: GuidUtils.raw(),
      }
    );
  }
}
